import ClubDetail from "./ClubDetail";
export default ClubDetail;
